import React, { useState } from "react";
import { Row, Col, Button, Card, Form, Dropdown, Table, Modal } from "react-bootstrap";
import ApiOrderService from "../../../../../core/api/api.ordersService";
import ApiFilesService from "../../../../../core/api/Api.filesService";
import Swal from "sweetalert2";
import ApiBasketLog from "../../../../../core/api/api.basketLog";
import ModalManager from "../ModalManager";
import _ from "lodash";
import OperatorUpdatePersonItemsCanceled from "./operatorUpdatePersonItemsCanceled/OperatorUpdatePersonItemsCanceled";
import SwalMessage from "../../../_Components/SwalMessage";
import ModalGaranti from "../ModalGaranti";
import { UploadFiles } from "../../../FilesService/UploadFiles";
import classNames from "classnames";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";

function BasketItemsIndex(props) {
  //PART 1 --------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  const [checkBoxList, setCheckBoxList] = useState([]); //-----------------------لیستی از افرادی که برای انجام عملیات انتخاب میشوند
  const [desValue, setDesValue] = useState(""); //-----------------------------------توضیحاتی که در اجرای عملیات برای شخص ثبت میشود در این استیت یا متغیر  ذخیره میشود
  const [ticketIssuanceDesValue, setTicketIssuanceDesValue] = useState("");
  const [show2, setShow2] = useState(false);
  const [ShowModalGaranty, setShowModalGaranty] = useState(false); //نمایش مدال پرداخت به گارانتی
  const [namedesc, setnamedesc] = useState();
  const [current, setCurrent] = useState();
  const [showModalAddPersonToItem, setShowModalAddPersonToItem] = useState(false);
  const [operatorCanceledMdal, setoperatorCanceledMdal] = useState(false);
  const [typeOfModalWaranty, settypeOfModalWaranty] = useState();
  const [showdescModal, setShowDescModal] = useState({
    basketId: null,
    basketItemId: null,
  });
  // const [selectedItemForEdit, setSelectedItemForEdit] = useState([]);
  // const [personsForEdit, setPersonsForEdit] = useState({});
  // const [basketItemId, setBasketItemId] = useState(0);

  const pageHeight = window.innerHeight;
  //PART 3 --------------------------------------------------------------------------------------------------------------------------------------------------
  const [Modali, setItem] = ModalManager();

  const handleShow =
    ({ nameModal, size, data }) =>
      (event) => {
        setItem({
          show: true,
          size: size,
          nameModal: nameModal,
          data: data,
        });
      };
  // PART 4 ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  const handleClose = () => setShow2(false);

  const handleCloseWarantyModal = () => setShowModalGaranty(false);

  //مدال صدور بلیط سیستمس و تغییر وضعیت بلیط
  const [ticketIssuanceModalConfig, setTicketIssuanceModalConfig] = useState({
    show: false,
    type: 1, //  صدور بلیط سیستمی1: , 2: تغییر وضعیت به رزرو
  });

  const handleOpenModalTicketIssuance = (current, type) => {
    if (current == 0) {
      SwalMessage({
        title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else setTicketIssuanceModalConfig({ show: true, type });
  };

  const handleCloseModalTicketIssuance = () => {
    setTicketIssuanceModalConfig({ ...ticketIssuanceModalConfig, show: false });
  };
  // update person in basket

  //مدال مشاهده مقدار بازگشتی از گارانتی

  //مدال پرداخت به گارانتی
  const handleModalGaranty = (current, typeOfModal) => {
    settypeOfModalWaranty(typeOfModal);
    if (current == 0) {
      SwalMessage({
        title: "جهت ثبت مبلغ  ابتدا آیتم های مدنظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else setShowModalGaranty(true);
  };

  const updateIssueTicket = async (type) => {
    const listId = checkBoxList.map((item) => item.id);
    const data = {
      basketId: parseInt(props.basketId),
      basketItemPersonIds: listId,
      description: ticketIssuanceDesValue,
    };

    try {
      let response = "";
      if (type == 1) {
        response = await ApiOrderService.issueTicket(data);
      } else if (type == 2) {
        response = await ApiOrderService.resetTicketStatusToReserved(data);
      }
      setTicketIssuanceModalConfig({ ...ticketIssuanceModalConfig, show: false });
      setCheckBoxList([]);
      Swal.fire({
        position: "bottom-end",
        reverseButtons: true,
        icon: response.succeeded ? "success" : "error",
        title: response.message,
        showConfirmButton: false,
        timer: 5000,
        focusCancel: true
      });
    } catch (error) {
      SwalMessage({ title: "خطا در صدور بلیط", iSsuccess: false, timer: 4000 });
    }
  };
  // صدور بلیط سیستمی
  const handleSystemTicketIssuance = async (current, type) => {
    //type:1 صدور بلیط سیستمی   type:2 تغییر وضعیت بلیط به رزرو
    if (current == 0) {
      SwalMessage({
        title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
    } else {
      const listId = checkBoxList.map((item) => item.id);
      const data = {
        basketId: parseInt(props.basketId),
        basketItemPersonIds: listId,
        description: ticketIssuanceDesValue,
      };
      try {
        let response = "";
        if (type == 1) {
          response = await ApiOrderService.issueTicket(data);
        } else if (type == 2) {
          response = await ApiOrderService.resetTicketStatusToReserved(data);
        }
        setTicketIssuanceModalConfig({ ...ticketIssuanceModalConfig, show: false });
        setCheckBoxList([]);
        Swal.fire({
          position: "bottom-end",
          reverseButtons: true,
          icon: response.succeeded ? "success" : "error",
          title: response.message,
          showConfirmButton: false,
          timer: 5000,
          focusCancel: true
        });
      } catch (error) {
        SwalMessage({ title: "خطا در  انجام عملیات", iSsuccess: false, timer: 4000 });
      }
    }
  };

  const handleUpdate = async (current) => {
    if (current == 0) {
      !_.isEmpty(checkBoxList)
        ? setoperatorCanceledMdal(!operatorCanceledMdal)
        : SwalMessage({
          title: "جهت ثبت کنسلی ابتدا آیتم های مدنظر را انتخاب نمایید.",
          iSsuccess: false,
          timer: 4000,
        });
    } else if (current === 5) {
      const data = showdescModal;
      data.description = desValue;
      if (!desValue) {
        SwalMessage({
          title: "لطفا  توضیحات را وارد کنید.",
          iSsuccess: false,
          timer: 4000,
        });
        return;
      }
      const response = await ApiBasketLog.postDescrib(data);
      if (response.succeeded) {
        setShow2(false);
        props.callBack();
        setDesValue("");
        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      }
    } else {
      (async () => {
        if (!checkBoxList.length) {
          SwalMessage({
            title: "ابتدا آیتم های مورد نظر را انتخاب نمایید.",
            iSsuccess: false,
            timer: 4000,
          })
          return
        }
        const listId = checkBoxList.map((item) => item.id);
        const data = {
          basketId: parseInt(props.basketId),
          listId: listId,
          currentStatus: current,
          description: desValue,
          verifyPayToWaranty: 0,
        };

        const response = await ApiOrderService.update(data);
        if (response.data == -1) {
          Swal.fire({
            title: "عملیات پرداخت مجدد به تامین کننده",
            text: "برای حداقل یکی از آیتم های انتخابی پرداخت به تامین کننده دارد،آیا مجددا پرداخت به تامین کننده انجام شود؟",
            icon: "question",
            showDenyButton: true,
            confirmButtonText: "بله",
            denyButtonText: "خیر",
            customClass: {
              actions: "my-actions",
              cancelButton: "order-1 right-gap btn btn-secondary",
              confirmButton: "order-2 btn btn-success px-5",
              denyButton: "order-3 btn btn-danger px-5",
            },
            focusCancel: true
          }).then(async (result) => {
            if (result.isConfirmed) {
              const data = {
                basketId: parseInt(props.basketId),
                listId: listId,
                currentStatus: current,
                description: desValue,
                verifyPayToWaranty: 2,
              };

              const response = await ApiOrderService.update(data);
              SwalMessage({ title: response.message, iSsuccess: response.succeeded });
            } else if (result.isDenied) {
              const data = {
                basketId: parseInt(props.basketId),
                listId: listId,
                currentStatus: current,
                description: desValue,
                verifyPayToWaranty: 1,
              };

              const response = await ApiOrderService.update(data);
              SwalMessage({ title: response.message, iSsuccess: response.succeeded });
            }
            setShow2(false);
            setCheckBoxList([]);
            props.callBack();
            setDesValue("");
          });
        } else {
          SwalMessage({ title: response.message, iSsuccess: response.succeeded });
        }
        setShow2(false);
        setCheckBoxList([]);
        props.callBack();
        setDesValue("");
      })();
    }
  };
  const getTicket = async (basketItemId) => {
    //تولید رشته تصادفی
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const randomLetters = Array.from({ length: 6 }, () => letters[Math.floor(Math.random() * letters.length)]).join("");
    const randomValue = `${Date.now()}${randomLetters}`;
    var response = await ApiFilesService.createTicketCode({ basketItemId: basketItemId });
    if (response?.succeeded && response.data) {
      const codeId = response.data;
      const downloadUrl = `${process.env.REACT_APP_Tafrihan_WEB}/ticket/${codeId}?q=${randomValue}`;
      window.open(downloadUrl, "_blank");
    } else {
    }
  };
  // PART 5------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  // handleSelect add or remove item id from checkBox list
  const handleSelect = (id, current, basketItemId) => {
    const data = { id: id, current: current, basketItemId: basketItemId };
    checkBoxList.some((item) => data.id === item.id)
      ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id))
      : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
  };

  // select all button
  const handleAllSelect = (list, boolian) => {
    if (!boolian) {
      const listFalseItem = list.filter((item) => !checkBoxList.some((data) => item.id === data.id));

      listFalseItem.map((item) => handleSelect(item.id, item.currentStatus, item.basketItemId));
    } else if (boolian) {
      const listTrueItem = list.filter((item) => checkBoxList.some((data) => item.id === data.id));

      listTrueItem.map((item) => handleSelect(item.id, item.currentStatus, listTrueItem.basketItemId));
    }
  };

  // PART 6--------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  // SHHOW MODAL FOR GET DESCRIBTION
  const handlemodaldescrib = (namedescs, currents) => {
    setShow2(true);
    setnamedesc(namedescs);
    setCurrent(currents);
  };

  const handleDescrib = (current) => {
    handleUpdate(current);
  };

  const getInputValueDescription = (event) => {
    const desValue = event.target.value;
    setDesValue(desValue);
  };
  const getInputValueTicketIssuanceDescription = (event) => {
    const desValue = event.target.value;
    setTicketIssuanceDesValue(desValue);
  };
  // // ===========================================================================]
  // const handleModalChangePerson = (personForEdit, basketId) => {
  //   setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
  //   setPersonsForEdit(personForEdit);
  //   setBasketItemId(basketId);
  // };
  // const callBackUpdatePerson = () => {
  //   setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
  //   props.callBack();
  // };
  // const callBackUpdatePerson2 = () => {
  //   setShowModalUpdatePersonInItem(!showModalUpdatePersonInItem);
  // };

  // // ----------------------------------------------------------------------------
  // const handleModalSegane = (basketId, item) => {
  //   setBasketItemId(basketId);
  //   setShowModalAddPersonToItem(!showModalAddPersonToItem);
  //   setSelectedItemForEdit(item);
  // };

  const callBackAddPerson = () => {
    setShowModalAddPersonToItem(!showModalAddPersonToItem);
    setoperatorCanceledMdal(!operatorCanceledMdal);
    props.callBack();
  };

  const callBackAddperson2 = () => {
    setoperatorCanceledMdal(!operatorCanceledMdal);
    setShowModalAddPersonToItem(!showModalAddPersonToItem);
    props.callBack();
  };

  // =--------------------------------------------------------------------------------

  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += "  " + "<i class='fas fa-info-circle text-small text-primary mx-2'></i>" + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }

  let showPrice = Intl.NumberFormat("en-US");

  return (
    <>
      <Modali />
      {/* --------------------مودال های استفاده شده در این کامپوننت  */}
      {/* {showModalAddPersonToItem && (
        <ModalAddPersonToItem
          bascketPersons={props.bascketPersons}
          callBack={callBackAddPerson}
          callBack2={callBackAddperson2}
          basketId={props.basketId}
          basketItemId={basketItemId}
        />
      )} */}
      {/* showModalAddPersonToItem && <AddServiceItems callBack={callBackAddPerson} callBack2={callBackAddperson2}
          basketId={props.basketId} basketItemPerson={props.bascketPersons} basketItem={selectedItemForEdit}/> */}

      {/* {showModalUpdatePersonInItem && (
        <ModalUpdatePersonInItems
          bascketPersons={props.bascketPersons}
          callBack={callBackUpdatePerson}
          callBack2={callBackUpdatePerson2}
          basketId={props.basketId}
        />
      )} */}
      {operatorCanceledMdal && (
        <OperatorUpdatePersonItemsCanceled
          callBack={callBackAddPerson}
          callBack2={callBackAddperson2}
          listPersons={checkBoxList}
          basket={props}
        />
      )}

      <Modal centered dialogClassName="modal-90w"
        show={show2} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{namedesc}</Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            handleDescrib(current);
          }}
        >
          <Modal.Body>
            <Form.Group>
              <Form.Label>{current !== 5 && `توضیحات`}</Form.Label>
              <Form.Control as="textarea" onChange={getInputValueDescription} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit">
              <SaveIcon />
              ثبت
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon />
              بستن
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal centered dialogClassName="modal-90w" show={ShowModalGaranty} onHide={handleCloseWarantyModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {typeOfModalWaranty == "payToWaranty" ? "محاسبه پرداختی به تامین کننده" : "محاسبه دریافتی از تامین کننده"}
          </Modal.Title>
        </Modal.Header>

        <ModalGaranti
          typeOfModalWaranty={typeOfModalWaranty}
          selectedItem={checkBoxList}
          basketId={props.basketId}
          setShowModalGaranty={setShowModalGaranty}
        />
      </Modal>

      {/* ---------------------برگشت وضعیت بلیط از استفاده شد به رزرو شده ----صدور بلیط سیستمی ------------*/}
      <Modal centered dialogClassName="modal-90w"
        show={ticketIssuanceModalConfig.show} onHide={handleCloseModalTicketIssuance}>
        <Modal.Header closeButton>
          <Modal.Title>
            {ticketIssuanceModalConfig.type === 1 ? "صدور بلیط سیستمی" : "تغییر وضعیت بلیط به رزرو شده"}
          </Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            updateIssueTicket(ticketIssuanceModalConfig.type);
          }}
        >
          <Modal.Body>
            <Form.Group>
              <Form.Label>توضیحات</Form.Label>
              <Form.Control as="textarea" onChange={getInputValueTicketIssuanceDescription} />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="success" type="submit">
              <SaveIcon />
              ثبت
            </Button>
            <Button variant="danger" onClick={handleCloseModalTicketIssuance}>
              <CloseIcon />
              بستن
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* -------------دراپ دون -------------------------------------------------------------------------------------------- */}
      <Dropdown className=" sticky-top " style={{ position: "fixed", top: pageHeight / 2, left: "-16px" }}>
        <Dropdown.Toggle size="sm" drop="up" variant="primary" className=" position-absolute right-0 fa-rotate-270">
          عملیات
        </Dropdown.Toggle>
        <Dropdown.Menu className="">
          <Dropdown.Item className="m-0 p-0 ">
            <div className="btn-group ml-auto my-0 py-0 col-12 " role="group">
              <button className="btn btn-outline-primary btn-sm col-7" onClick={() => handleUpdate(1)}>
                درحال پیگیری
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handlemodaldescrib("درحال پیگیری", 1)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>

          <Dropdown.Item className="mx-auto m-0 p-0 ">
            <div className="btn-group ml-auto  my-0 py-0 col-12" role="group">
              <button className="btn btn-outline-primary btn-sm col-7" onClick={() => handleUpdate(2)}>
                رها سازی
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handlemodaldescrib("رها سازی ", 2)}
              >
                توضیحات
              </button>
            </div>{" "}
          </Dropdown.Item>
          <Dropdown.Item className="mx-auto m-0 p-0">
            <div className="btn-group ml-auto my-0 py-0 col-12" role="group">
              <button className="btn btn-outline-primary btn-sm col-7" onClick={() => handleUpdate(3)}>
                انجام شد
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handlemodaldescrib("انجام شد", 3)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>
          <Dropdown.Item className="mx-auto m-0 p-0">
            <div className="btn-group ml-auto my-0 py-0 col-12" role="group">
              <button className="btn btn-outline-primary btn-sm col-7" onClick={() => handleUpdate(4)}>
                انجام نشد
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handlemodaldescrib("انجام نشد", 4)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>
          <Dropdown.Item className="mx-auto m-0 p-0">
            <div className="btn-group ml-auto my-0 py-0 col-12" role="group">
              <button
                className="btn btn-outline-primary btn-sm col-7"
                onClick={() => {
                  handleSystemTicketIssuance(checkBoxList, 1);
                }}
              >
                صدور بلیط سیستمی
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handleOpenModalTicketIssuance(checkBoxList, 1)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>

          <Dropdown.Item className="mx-auto m-0 p-0">
            <div className="btn-group ml-auto my-0 py-0 col-12" role="group">
              <button
                style={{ whiteSpace: "initial" }}
                className="btn btn-outline-primary btn-sm col-7 px-1"
                onClick={() => {
                  handleSystemTicketIssuance(checkBoxList, 2);
                }}
              >
                تغییر وضعیت بلیط از ابطال به رزرو
              </button>
              <button
                className="btn btn-outline-primary btn-sm col-5"
                onClick={() => handleOpenModalTicketIssuance(checkBoxList, 2)}
              >
                توضیحات
              </button>
            </div>
          </Dropdown.Item>
          <Dropdown.Item className="m-0 p-0 px-4 ">
            {/* <div className="btn-group ml-auto my-0 py-0 col-12 " role="group"> */}
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => handleUpdate(0)}
            >
              درخواست کنسل
            </button>
          </Dropdown.Item>
          <Dropdown.Item className="m-0 p-0 px-4 ">
            {/* <div className="btn-group ml-auto my-0 py-0 col-12 " role="group"> */}
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => handleModalGaranty(checkBoxList, "payToWaranty")}
            >
              پرداخت به تامین کننده
            </button>
          </Dropdown.Item>
          <Dropdown.Item className="m-0 p-0 px-4 ">
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => {
                handleModalGaranty(checkBoxList, "receiveFromWaranty");
              }}
            >
              دریافت از تامین کننده
            </button>
          </Dropdown.Item>

          <Dropdown.Item className="m-0 p-0 px-4 "></Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {/* ========================================================================================================================== */}
      {/* -------------------------ایتم ها ی سبد خرید ------------------------------------------------------------------------------- */}
      <div className="mt-5">
        {props &&
          props.basketItems &&
          props.basketItems.map((item, index) => (
            <Card key={index} className=" rounded-xl mt-1 mx-0 p-3 bg-white border border-secondary">
              <div className="my-0">
                <Row className="align-items-center mb-2 border-bottom">
                  <Col xs="12" md xl>
                    <h1 className="mx-3  text-hover-primary fs-large">{item.amusementServiceName} </h1>
                  </Col>
                  <Col
                    xs="12"
                    xl="auto"
                    className="d-flex align-items-center justify-content-xl-start mt-3 mt-xl-0 mb-3"
                  >
                    <div className="d-flex justify-content-end ">
                      <Button
                        variant="secondary"
                        className="mr-2"
                        onClick={() => {
                          handlemodaldescrib("ثبت توضیحات", 5);
                          setShowDescModal((prev) => ({
                            basketId: item.basketId,
                            basketItemId: item.id,
                          }));
                        }}
                      >
                        <i className="far fa-comment-alt pr-0 text-small"></i>
                        {/* توضیحات */}
                      </Button>
                      <button
                        type="button"
                        className="btn btn-light-secondary mr-2"
                        onClick={handleShow({
                          nameModal: "historyItem",
                          size: "lg",
                          data: {
                            BasketId: props.basketId,
                            BasketItemId: item.id,
                          },
                        })}
                      >
                        <p className="fas fa-history text-dark fa-sm my-0"></p>
                      </button>
                      <UploadFiles showText={"آپلود فایل"} basketItemId={item.id}></UploadFiles>
                    </div>
                  </Col>
                </Row>
              </div>
              {/*------------------------------------------------------- مشخصات سفارش ------------------------------------------*/}
              <div className="">
                <Row className=" my-2 pl-2 align-items-center">
                  <Col xs="12" md className="text-muted">
                    <p
                      className=" "
                      dangerouslySetInnerHTML={{
                        __html: showDetail(item.details),
                      }}
                    >
                      {/* جزییات سفارش :  */}
                      {/* {showDetail(item.details)} */}
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2">
                    <p className=" ">
                      <span className="fas fa-user-tie text-primary mr-2"></span>
                      {item.totalCount} نفر{" "}
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2">
                    <p className="">
                      <span className="far fa-calendar-check text-info mr-2"></span>
                      {item.checkInDate}{" "}
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2" className="">
                    <p className=" " data-bs-toggle="tooltip" title="مبلغ نهایی تفریح">
                      <span className="far fa-money-bill-alt text-success  mr-2"></span>
                      {showPrice.format(item.sumPrice)}{" "}
                      <span>
                        <small> تومان </small>
                      </span>
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2" className="">
                    <p className=" " data-bs-toggle="tooltip" title="مبلغ پرداختی به تامین کننده">
                      <span className="far fa-money-bill-alt text-danger mr-2"></span>
                      {showPrice.format(item.warantyAmount)}{" "}
                      <span>
                        <small> تومان </small>
                      </span>
                    </p>
                  </Col>
                </Row>
              </div>

              {/* ------------------------------------------------لیست افراد حاضر در ایتم------------------------------------------------------------ */}
              <div className="bg-white rounded-4 border border-secondary mb-4">
                <Table responsive className="mt-1 tbl-scroll  rounded-4">
                  <thead>
                    <tr>
                      <td className="bg-white text-center" style={{ minWidth: "50px" }}>
                        <input
                          type="checkbox"
                          onChange={() =>
                            handleAllSelect(
                              item.basketItemPersons,
                              item?.basketItemPersons.filter((item) => checkBoxList.some((data) => item.id === data.id))
                                .length === item?.basketItemPersons.length,
                            )
                          }
                          checked={
                            item?.basketItemPersons.filter((item) => checkBoxList.some((data) => item.id === data.id))
                              .length === item?.basketItemPersons.length && item?.basketItemPersons.length > 0
                          }
                          className="my-1 "
                        />{" "}
                      </td>
                      <td className="bg-white"></td>
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-muted">شماره بلیط</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "130px" }}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-muted">نام و نام خانوادگی</p>
                      </td>
                      {!!item.hallEventId &&
                        <td className="bg-white" style={{ minWidth: "130px" }}>
                          <p className="text-center my-1 ml-6 ml-md-0 text-muted">صندلی</p>
                        </td>
                      }
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">نرخ مصوب</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 text-muted my-1">نرخ فروش</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 text-muted my-1">تخفیف کد</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "100px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">قیمت نهایی</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">تامین کننده</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">جریمه</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "90px" }}>
                        <p className="text-md-center ml-6 ml-md-0 my-1 text-muted">وضعیت</p>
                      </td>
                      <td className="bg-white" style={{ minWidth: "90px" }}>
                        <p className="text-center  ml-md-0 my-1 text-muted">وضعیت کنسلی</p>
                      </td>
                    </tr>
                  </thead>
                  <tbody className="border-top">
                    {item.basketItemPersons.length !== 0 ? (
                      item.basketItemPersons.map((item1, index1) => (
                        <tr
                          key={index1}
                          className={classNames(
                            "bg-hover-light-primary position-relative",
                            item1.currentStatus == 1
                              ? "bg-light-blue"
                              : item1.currentStatus == 3
                                ? "bg-light-green "
                                : item1.currentStatus == 4 && "bg-light-orange ",
                          )}
                        >
                          <td
                            style={{ minWidth: "50px" }}
                            className="text-center  position-relative"
                            onClick={() => handleSelect(item1.id, item1.currentStatus, item1.basketItemId)}
                          >
                            {item1.cancelStatus == 1 || item1.cancelStatus == 2 ? (
                              <div
                                className="position-absolute pulse-icon"
                                style={{ right: "-1px", top: "52%", transform: "translateY(-50%)", zIndex: "1" }}
                              >
                                <i className="fa fa-caret-left text-danger"></i>
                              </div>
                            ) : (
                              ""
                            )}
                            {item1.currentStatus == 1 && item1.trackingTheCurrentUser === true ? (
                              <span
                                style={{
                                  width: "6px",
                                  height: "6px",
                                  backgroundColor: "#92b6e1",
                                  display: "inline-block",
                                  borderRadius: "10px",
                                  marginLeft: "4px",
                                  position: "absolute",
                                  right: "9px",
                                  top: "15px",
                                  zIndex: "1",
                                }}
                              ></span>
                            ) : (
                              ""
                            )}
                            <div className="">
                              <input
                                type="checkbox"
                                checked={checkBoxList.some((item) => item1.id === item.id)}
                                onChange={() => {
                                  handleSelect(item1.id, item1.currentStatus, item1.basketItemId)
                                }}
                                onClick={(event) => {
                                  event.stopPropagation()
                                }}
                                className=" "
                              />
                            </div>
                          </td>
                          {item1.issueTicketType == 2 ? (
                            <td onClick={() => getTicket(item1.basketItemId)}>
                              <i
                                className={`${item1.currentStatus == 3 ? "text-warning flaticon2-print icon-md mt-3" : "flaticon2-print icon-md mt-3"} `}
                                onClick={() => getTicket(item1.basketItemId)}
                              ></i>
                            </td>
                          ) : (
                            <td></td>
                          )}
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.id}</p>
                          </td>
                          <td className="" onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.personFullName}</p>
                          </td>
                          {!!item.hallEventId &&
                            <td className="" onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                              <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">جایگاه: {item1.hallBlockName}
                                <br />
                               ردیف: {item1.hallRowName}
                                <br />
                                صندلی: {item1.hallSeatName}
                              </p>
                            </td>
                          }
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p
                              className="text-center ml-6 ml-md-0 my-1 text-hover-primary"
                              style={{ textDecoration: "line-through" }}
                            >
                              {showPrice.format(item1.originalPrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p
                              className="text-center ml-6 ml-md-0 text-hover-primary my-1"
                              style={item1.promoCodeDiscountPrice > 0 ? { textDecoration: "line-through" } : {}}
                            >
                              {showPrice.format(item1.salePrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className="text-center ml-6 ml-md-0 text-hover-primary my-1">
                              {showPrice.format(item1.promoCodeDiscountPrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className="text-center  ml-md-0 my-1 text-hover-primary">
                              {showPrice.format(item1.price)}
                            </p>
                          </td>
                          <td
                            onClick={() => handleSelect(item1.id, item1.currentStatus)}
                            style={{ color: "#0e0e0e70" }}
                          >
                            <p
                              className={
                                item1.warantyAmount >= 0
                                  ? "text-center ml-6 ml-md-0 my-1 text-hover-primary"
                                  : "text-center ml-6 ml-md-0 my-1 text-hover-primary text-danger"
                              }
                            >
                              {showPrice.format(item1.warantyAmount)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className="text-center ml-6 ml-md-0 my-1 text-hover-primary">
                              {showPrice.format(item1.fineAmount)}
                            </p>
                          </td>
                          {/* -------------------------------- وضعیت-------------------------------------------------------------*/}
                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)} className="px-0 mx-0">
                            <p className="text-center  ml-md-0 my-1 d-flex justify-content-center align-items-center">
                              {item1.currentStatus == 1 && item1.trackingTheCurrentUser === true ? (
                                <span
                                  style={{
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor: "#92b6e1",
                                    display: "inline-block",
                                    borderRadius: "10px",
                                    marginLeft: "4px",
                                  }}
                                ></span>
                              ) : (
                                ""
                              )}

                              <span
                                className={
                                  classNames(item1.currentStatus == 0 || item1.currentStatus == 2
                                    ? "color-blue-text"
                                    : item1.currentStatus == 1
                                      ? "color-blue-light-text"
                                      : item1.currentStatus == 3
                                        ? "color-green-text"
                                        : item1.currentStatus == 4 && "color-orange-text")
                                }
                              >
                                {item1.currentStatusS}
                              </span>
                            </p>
                          </td>

                          <td onClick={() => handleSelect(item1.id, item1.currentStatus)}>
                            <p className={"text-center ml-md-0 my-1 "}>
                              <span
                                className={
                                  classNames(item1.cancelStatus == 1 || item1.cancelStatus == 3
                                    ? "color-red-text "
                                    : item1.cancelStatus == 2
                                      ? "color-pink-light-text"
                                      : item1.cancelStatus == 4
                                        ? "color-brown-text "
                                        : item1.cancelStatus == 5 && "color-orange-light-text")
                                }
                              >
                                {item1.cancelStatus == 0 ? "" : item1.cancelStatusS}
                              </span>
                            </p>
                          </td>

                          <td className="  ">
                            <div className="btn-group-sm d-flex justify-content-center   mx-5">
                              <button
                                type="button"
                                className="btn mx-1 btn-light-secondary  "
                                onClick={handleShow({
                                  nameModal: "historyItem",
                                  size: "lg",
                                  data: {
                                    BasketId: props.basketId,
                                    BasketItemId: item.id,
                                    BasketItemPersonId: item1.id,
                                  },
                                })}
                              >
                                <p className="fas fa-history text-dark fa-sm  my-0"></p>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="text-danger ">
                        <td colSpan="13">
                          <small className="text-danger ">برای این فعالیت هنوز فردی ثبت نشده است !!</small>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card>
          ))}
      </div>
    </>
  );
}

export default BasketItemsIndex;
